import React from "react";
import { getString } from "../../utilities";
import SubscriptionCard from "./subscriptionCard";
import { getLangCode, language } from "../../config";
import PlanPerks from "./PlanPerks";

export default function FamilyPlans({
  plan,
  setPlan,
  planAmount,
  setPlanAmount,
  planData,
  activeClick,
  className = "",
}) {
  const langCode = getLangCode();

  return (
    <div className="subscribe-plans-wrapper">
      <div className={`${className} transition-count-1`}>
        <h2>
          {getString(langCode === language.la ? "subscribe.plans.family.title.6" : "subscribe.plans.family.title.5")}
        </h2>

        <PlanPerks devices={getString("subscribe.plans.perks.devices.family")} />
      </div>

      <div className={`${className} transition-count-2`}>
        <div className="subscribe-plans-container" role="radiogroup">
          <SubscriptionCard
            setPlan={setPlan}
            planAmount={planAmount}
            setPlanAmount={setPlanAmount}
            planData={planData}
            plan={plan}
            subscription="m12"
            isBest={true}
            showRenew={true}
            tabIndex={0}
            role="radio"
            activeClick={activeClick}
          />
          <SubscriptionCard
            setPlan={setPlan}
            planAmount={planAmount}
            setPlanAmount={setPlanAmount}
            planData={planData}
            plan={plan}
            subscription="m1"
            showRenew={true}
            tabIndex={0}
            role="radio"
            activeClick={activeClick}
          />
        </div>

        <div className="subscribe-plans-description">{getString("subscribe.plans.description")}</div>
      </div>
    </div>
  );
}
